<template>
	<v-card class="text-xs-left warning-border-left" outlined elevation="2">
		<v-card-title class="text-h6 font-weight-bold">
			<v-icon class="mr-2" color="warning">mdi-alert-circle-outline</v-icon>
			Your Account is Pending Cancellation
		</v-card-title>

		<v-card-text class="pt-1">
			<p>
				Your account will remain active until the end of your current billing period on
				<strong>{{ subscriptionEndDateLocal }}</strong
				>. You can continue to use all features until that time.
			</p>

			<ul>
				<li><strong>Billing:</strong> You won't be charged again after the cancellation, but you can continue to use the system until your billing period ends.</li>
				<li><strong>Free Trial:</strong> If you're still on a free trial, you'll retain full access until the trial period ends.</li>
				<li><strong>Data Retention:</strong> Your account and data will remain intact should you choose to reactivate before the end of your billing period.</li>
			</ul>

			<p class="mt-3">If you would like to reverse this cancellation, please contact support at <a href="mailto:support@yourhrsystem.com">support@yourhrsystem.com</a></p>
		</v-card-text>
	</v-card>
</template>

<script>
	import { mapGetters } from 'vuex';

	export default {
		computed: {
			...mapGetters({
				loggedInSubscription: 'loggedInSubscription'
			}),
			subscriptionEndDateLocal() {
				if (!this.loggedInSubscription || !this.loggedInSubscription.endDateUtc) return;

				const date = new Date(Date.parse(this.loggedInSubscription.endDateUtc));
				return date.toLocaleDateString('en-AU');
			}
		}
	};
</script>

<style scoped>
	.warning-border-left {
		border-left: 4px solid;
		border-color: #ffc107 !important;
	}
</style>
